import React from 'react';
import { HomeInstallAppScreen } from 'fitbeat.react-native-components';
import { FullScreenLayout } from './Layouts/FullScreenLayout';
import { HomeCarouselAuthLayout } from './Layouts/HomeCarouselAuthLayout';
const isMobile = window.innerWidth <= 550;
const WappingComponent =  isMobile ? FullScreenLayout : HomeCarouselAuthLayout;
export const HomeInstallAppContainer = (props) => (
  <WappingComponent hasAccessToAStudioGym={false} {...props}>
    <HomeInstallAppScreen {...props} />
  </WappingComponent>
);
